import { useEffect, useState } from 'react';
import { Box, Divider, Drawer, Toolbar, useMediaQuery, type Theme } from '@mui/material';
import { useSidebarState, type SidebarProps } from 'react-admin';
import ForgeWordmark from './components/ForgeWordmark.tsx';
import { DRAWER_WIDTH } from './theme';

const drawerPaper = {
  '& .MuiDrawer-paper': {
    width: DRAWER_WIDTH,
    bgcolor: 'primary.dark',
    color: '#fff',
    borderRight: 0
  }
};

/**
 * Permanent from md up and a temporary drawer below, like the restoration platform.
 * react-admin's own Sidebar switches at sm and collapses to icons instead.
 */
const CustomSidebar = ({ children }: SidebarProps) => {
  const isDesktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'), { noSsr: true });
  const [open, setOpen] = useSidebarState();
  // react-admin stores `open` and defaults it to true from sm up, so the phone drawer only
  // follows it once the effect below has closed it for this breakpoint.
  const [phoneReady, setPhoneReady] = useState(false);

  useEffect(() => {
    setOpen(isDesktop);
    setPhoneReady(!isDesktop);
  }, [isDesktop, setOpen]);

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Toolbar>
        <ForgeWordmark />
      </Toolbar>
      <Divider sx={{ borderColor: 'rgba(255,255,255,.14)' }} />
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>{children}</Box>
    </Box>
  );

  if (isDesktop) {
    return (
      <Box component="aside" sx={{ width: DRAWER_WIDTH, flexShrink: 0 }}>
        <Drawer variant="permanent" open sx={drawerPaper}>
          {content}
        </Drawer>
      </Box>
    );
  }

  return (
    <Drawer
      variant="temporary"
      open={phoneReady && open}
      onClose={() => setOpen(false)}
      ModalProps={{ keepMounted: true }}
      sx={drawerPaper}
    >
      {content}
    </Drawer>
  );
};

export default CustomSidebar;
